'use strict';

/**
 * createdBy cc 2016-6-24
 * 时间选择器
 * callback为下拉组件原有参数
 * fromdate,untildate为自定义的开始时间与结束时间
 * 功能为下拉组件基础上增加自定义时间功能
 */

angular.module('trsTimeSelectModule', [])
    .directive('trsTimeSelect', ['$location', '$filter', 'trsHttpService', '$stateParams', '$state', '$timeout', 'modalDialog', function($location, $filter, trsHttpService, $stateParams, $state, $timeout, modalDialog) {
        return {
            restrict: 'EA',
            templateUrl: './components/util/trsTimeSelect/trsTimeSelect_tpl.html',
            scope: {
                placeholder: '@',
                callback: '&',
                fromdate: '=',
                untildate: '=',
                disabled: '=',
                isBr: '=',
            },
            // <trs-single-select selected-option="iWoAllSelected" callback="queryByiWoAll()" options="iWoAll" class="pull-left"></trs-single-select>
            link: function(scope, iElement, iAttrs) {
                var from, to, indx, $datepickerCalendar;
                init();

                /**
                 * [init description]初始化
                 *
                 * @return  {[type]}  [return description]
                 */
                function init() {
                    scope.istitle = iAttrs.istitle || false;
                    scope.placeholder = !scope.placeholder ? '选择日期' : scope.placeholder;
                    scope.inline = angular.isUndefined(iAttrs.inline) ? true : scope.inline === true;
                    temp();
                    if (scope.fromdate && scope.untildate) {
                        from = new Date(Date.parse(scope.fromdate));
                        to = new Date(Date.parse(scope.untildate));
                        scope.showDate = dateFormat(from) + '至' + (scope.isBr ? '<br>' : '') + dateFormat(to);
                    } else {
                        from = to = new Date();
                    }
                    indx = 1;
                    $datepickerCalendar = iElement.find('.datepicker-calendar');
                    datePicker();
                    if (!scope.inline) {
                        scope.$on('$destroy', function() {
                            $('.datepicker').remove();
                        });
                    }

                    // 该广播接受由调用者发送来的清除日期控件内容的命令，并不调用回调函数
                    scope.$on('clearDateWithOutCallback', function(event, data) {
                        clearDate();
                    });
                    initBlur();
                    initScrollHide();
                    initChooseTime();
                }

                /**
                 * [initChooseTime description]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initChooseTime() {
                    scope.$watch('untildate', function(newV, oldV) {
                        if (newV) {
                            $datepickerCalendar.DatePickerSetDate([scope.fromdate, scope.untildate,]);
                        }
                    });
                }

                /**
                 * [initScrollHide description]
                 * @return {[type]} [description]
                 */
                function initScrollHide() {
                    $('body').bind('mousewheel', myScroll);

                    /**
                     * [myScroll description]滚动事件
                     *
                     * @param   {[type]}  e  [e description]
                     *
                     * @return  {[type]}     [return description]
                     */
                    function myScroll(e) {
                        var $target = $(e.target);
                        var $datepicker = !scope.inline ? $('#' + scope.myDatePircke.attr('datepickerId')) : iElement.find('.datepicker');
                        if ($target.parents('.datepicker-calendar').length === 0 && !$datepicker.hasClass('datepicker-calendar')) {
                            iElement.find('.cur').removeClass('cur').hide();
                            $datepicker.hide();
                        }
                    }
                    scope.$on('$destroy', function() {
                        $('body').unbind('mousewheel', myScroll);
                    });
                }

                /**
                 * [initBlur description] 初始化焦点
                 * @return {[type]} [description]
                 */
                function initBlur() {
                    $('html').unbind('click', myBlur).bind('click', myBlur);

                    /**
                     * [myBlur description]
                     *
                     * @param   {[type]}  $event  [$event description]
                     *
                     * @return  {[type]}          [return description]
                     */
                    function myBlur($event) {
                        var $target = $($event.target);
                        var $datepicker = !scope.inline ? $('#' + scope.myDatePircke.attr('datepickerId')) : iElement.find('.datepicker');
                        if ($target.parents('.trsTimeSelect')[0] !== iElement.find('.trsTimeSelect')[0]) {
                            iElement.find('.cur').removeClass('cur').hide();
                            $datepicker.hide();
                        }
                    }
                    scope.$on('$destroy', function() {
                        $('html').unbind('click', myBlur);
                    });
                }
                scope.$watch('fromdate', function() {
                    from = new Date(Date.parse(scope.fromdate));
                    to = new Date(Date.parse(scope.untildate));
                    if (angular.isDefined(scope.fromdate) && scope.fromdate != '' && scope.untildate != '') {
                        if (scope.showDate != scope.placeholder && scope.showDate != '请选择时间') {
                            scope.showDate = dateFormat(from) + '至' + (scope.isBr ? '<br>' : '') + dateFormat(to);
                        }
                    }
                });

                /**
                 * [clearDate description] 清除日期，并调用callback
                 * @param  {[type]} event [description]
                 * @return {[type]}       [description]
                 */
                scope.clearDateWithCallback = function(event) {
                    clearDate(event, function() {
                        scope.callback();
                    });
                };

                /**
                 * [clearDate description]清除日期
                 *
                 * @param   {[type]}  event    [event description]
                 * @param   {[type]}  success  [success description]
                 *
                 * @return  {[type]}           [return description]
                 */
                function clearDate(event, success) {
                    if (event) {event.stopPropagation();}
                    $timeout(function() {
                        if (!scope.inline) {
                            scope.showDate = scope.placeholder ? scope.placeholder : '请选择时间';
                            var attr1 = iAttrs['fromdate'].split('.');
                            var attr2 = iAttrs['untildate'].split('.');
                            scope.$parent[attr1[0]][attr1[1]] = '';
                            scope.$parent[attr2[0]][attr2[1]] = '';
                            scope.myDatePircke.DatePickerClear();
                            iElement.find('.datepicker-calendar').click();
                            // iElement.find(".datepicker-calendar").hide();
                            $('.datepicker').hide();
                            iElement.find('.date-range-field').attr('class', 'date-range-field');
                            if (angular.isFunction(success)) {success();}
                        } else {
                            scope.showDate = scope.placeholder ? scope.placeholder : '请选择时间';
                            var attr1 = iAttrs['fromdate'].split('.');
                            var attr2 = iAttrs['untildate'].split('.');
                            scope.$parent[attr1[0]][attr1[1]] = '';
                            scope.$parent[attr2[0]][attr2[1]] = '';
                            scope.myDatePircke.DatePickerClear();
                            iElement.find('.datepicker-calendar').click();
                            iElement.find('.datepicker-calendar').hide();
                            iElement.find('.date-range-field').attr('class', 'date-range-field');
                            if (angular.isFunction(success)) {success();}
                        }
                    });
                }

                /* scope.$watch("$parent." + iAttrs['fromdate'].split(".")[0] + "." + iAttrs['fromdate'].split(".")[1], function(newV, oldV) {
                    if (oldV !== "" && newV === "") {
                        scope.clearDateWithCallback();
                    }
                });*/

                /**
                 * [datePicker description]调用时间控件
                 *
                 * @return  {[type]}  [return description]
                 */
                function datePicker() {
                // console.log(scope.mode)
                    var options = {
                        inline: scope.inline,
                        date: [from, to,],
                        calendars: 1,
                        mode: 'range',
                        onChange: function(dates, el) {
                            var fromDate = dateFormat(dates[0]);
                            var untilDate = dateFormat(dates[1]);
                            if (indx == 2) {
                                if (!scope.inline) {
                                    $('.datepicker').hide();
                                } else {
                                    $datepickerCalendar.removeClass('cur').hide();
                                }
                                var attr1 = iAttrs['fromdate'].split('.');
                                var attr2 = iAttrs['untildate'].split('.');
                                scope.$parent[attr1[0]][attr1[1]] = $filter('date')(fromDate, 'yyyy-MM-dd').toString();
                                scope.$parent[attr2[0]][attr2[1]] = $filter('date')(untilDate, 'yyyy-MM-dd').toString();
                                $timeout(function() {
                                    if (new Date(fromDate).getTime() <= new Date(untilDate).getTime()) {
                                        scope.callback();
                                    } else {
                                        modalDialog.alertType('时间检索失败', '开始时间不能大于结束时间', 'error', false);
                                    }
                                });
                                indx = 1;
                            } else {
                                untilDate = '结束日期';
                                indx++;
                            }
                            $timeout(function() {
                                scope.showDate = fromDate + '至' + (scope.isBr ? '<br>' : '') + untilDate;
                            });
                        },
                        onRenderCell: function(el, date) {
                            var obj = {};
                            var maxDate = iAttrs['maxdate'];
                            var minDate = iAttrs['mindate'];
                            if (maxDate === undefined && minDate === undefined) {
                                return obj;
                            }
                            if (maxDate) {
                                maxDate = maxDate === 'today' ? new Date() : new Date(Date.parse(maxDate));
                                if (date > maxDate) {obj.disabled = true;}
                            }
                            if (minDate) {
                                minDate = minDate === 'today' ? new Date() : new Date(Date.parse(minDate));
                                if (date < minDate) {obj.disabled = true;}
                            }
                            return obj;
                        },
                    };
                    scope.myDatePircke = $datepickerCalendar.DatePicker(options);
                    if (!scope.untildate) {
                        scope.myDatePircke.DatePickerClear();
                    }
                }

                /**
                 * [dateFormat description]时间格式化
                 *
                 * @param   {[type]}  date  [date description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function dateFormat(date) {
                    var year = date.getFullYear();
                    var month = (date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
                    var day = (date.getDate()) >= 10 ? (date.getDate()) : '0' + (date.getDate());
                    return year + '-' + month + '-' + day;
                }

                /**
                 * [temp description]
                 *
                 * @return  {[type]}  [return description]
                 */
                function temp() {
                    iElement.delegate('.date-range-field', 'click', function(event) {
                        var $datepicker;
                        if (!scope.inline) {
                            $datepicker = $('#' + scope.myDatePircke.attr('datepickerId'));
                            if ($datepicker.css('display') === 'block') {
                                $datepicker.hide();
                            } else {
                                $datepicker.css({
                                    display: 'block',
                                    left: iElement.offset().left,
                                    top: iElement.offset().top + iElement.innerHeight(),
                                });
                                positionFix($datepicker);
                            }
                        } else {
                            $datepicker = iElement.find('.datepicker');
                            if ($(this).siblings().hasClass('cur')) {
                                $(this).siblings().removeClass('cur').hide();
                                iElement.find('.cur').removeClass('cur').hide();
                                $datepicker.hide();
                            } else {
                                $(this).siblings().addClass('cur').show();
                                $datepicker.show();
                            }
                        }
                        
                        /**
                         * [positionFix description]位置不够向上冒
                         *
                         * @param   {[type]}  $dom  [$dom description]
                         *
                         * @return  {[type]}        [return description]
                         */
                        function positionFix($dom) {
                            var windowHeight = window.innerHeight;
                            var datepickerTop = $dom.offset().top;
                            var datepickerHeight = $dom.height();
                            var buttonHeight = iElement.find('.trsTimeSelect')[0].offsetHeight;
                            if (datepickerTop + datepickerHeight > windowHeight) {
                                $dom.offset({ top: datepickerTop - datepickerHeight - buttonHeight, });
                            }
                        }
                    });
                    iElement.delegate('.date-range-field', 'mouseenter', function(event) {
                        if (scope.fromdate && scope.untildate) {$(this).addClass('acitve');}
                        return false;
                    });
                    iElement.delegate('.date-range-field', 'mouseleave', function(event) {
                        $(this).removeClass('acitve');
                        return false;
                    });
                }
            },
        };
    },]);
